import { render } from "./Historical.vue?vue&type=template&id=7f8b84a2"
import script from "./Historical.vue?vue&type=script&lang=js"
export * from "./Historical.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__